import { useRouterState } from '@tanstack/react-router'

import { withinPrefix } from '@/components/layout/use-active-section'

const MARKET_PREFIX = '/market'

/**
 * The Market pages the mock draws with the default rail (Market news + Popular stocks) rather than
 * the Market rail: Market update, Market news (list and article) and Newsletters (list and issue).
 */
const DEFAULT_RAIL_PREFIXES = ['/market/update', '/market/news', '/market/newsletters'] as const

/**
 * True on `/market` and its tool pages, where the mock's Market rail draws (Fear and greed, Top
 * movers, 52-week range) — never on `/stocks/*`, which draws its own compact reading through
 * `StockRail`'s `MarketMoodBlock`, and never on the news pages above, which keep the default rail.
 * The Market rail's own blocks draw only here, and their queries run only where they draw.
 */
export const isMarketRoute = (pathname: string): boolean =>
  withinPrefix(pathname, MARKET_PREFIX) &&
  !DEFAULT_RAIL_PREFIXES.some((prefix) => withinPrefix(pathname, prefix))

/** The router's own pathname, put through `isMarketRoute`. */
export const useIsMarketRoute = (): boolean =>
  useRouterState({ select: (state) => isMarketRoute(state.location.pathname) })
